import * as React from 'react';
import styles from './TradeInHeader.scss';
import MainFeaturesLayout from '~/Layouts/Features/Views/MainFeaturesLayout/MainFeaturesLayout';
import { t } from '~/utils/localization';
import classNames from 'classnames';
import { ITradeItem } from '~/types/tradein';
import { items } from '@wg/wows-entities/const';
import { useDispatch, useSelector } from 'react-redux';
import { changeVisiblePopup } from '~/Actions/ActionApp';
import { POPUPS_NAME } from '~/components/PopupManager';
import { getInlineShipInfo } from '~/utils/ships/ships';
import PortPreviewButton, { PortPreviewTemplate } from '~/components/PortPreviewButton/PortPreviewButton';
import { openPort } from '~/api/WoWsClient';
import { PortPreviewType } from '~/components/Port/settings';
import { isInGameBrowser } from '~/utils/utils';
import { settings } from '~/utils/settings';
import { State } from '~/Reducers';
import equal from 'fast-deep-equal/react';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';

interface ITradeInHeader {
    item: ITradeItem;
    className?: string;
}

interface IStateSelector {
    shipFeatureMap: ShipFeatureMap;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        shipFeatureMap: state.ReducerFeatures.shipFeatureMap,
    };
};

const HeaderContent = ({ item }: ITradeInHeader) => {
    const dispatch = useDispatch();
    const { shipFeatureMap } = useSelector<State, IStateSelector>(stateSelector, equal);

    switch (item?.type) {
        case items.VEHICLES:
            const onClick = () => dispatch(changeVisiblePopup(POPUPS_NAME.ITEM_DESCRIPTION_POPUP, true, { item }));
            if (!shipFeatureMap?.[item.identifier]) {
                return null;
            }
            return (
                <div className={styles.featured}>
                    <div className={styles.featuredTitle}>{t('Ключевые особенности корабля')}</div>
                    <MainFeaturesLayout shipId={item.identifier} detailedFeatures={true} />
                    <div className={styles.additionalLink}>
                        <span onClick={onClick}>{t('Подробнее')}</span>
                    </div>
                </div>
            );
    }

    return null;
};

const getSubContent = (item: ITradeItem) => {
    switch (item?.type) {
        case items.VEHICLES:
            return (
                <>
                    {isInGameBrowser && (
                        <div className={styles.subContentBlock}>
                            <PortPreviewButton
                                template={PortPreviewTemplate.flat}
                                onClick={() => {
                                    openPort(item.identifier, -1, item.type, PortPreviewType.DEFAULT, -1);
                                }}
                            />
                        </div>
                    )}
                </>
            );
    }

    return null;
};

const TradeInHeader = ({ item, className }: ITradeInHeader) => {
    const classesContent = classNames(
        styles.content,
        {
            [styles.hidden]: !item?.identifier,
        },
        className,
    );

    return (
        <div className={classesContent}>
            <div className={styles.header}>
                <div className={styles.title}>{!!item && <WoWSEntity type={item.type} id={item.identifier} presentation={{ renderWithoutFade: true }} />}</div>
                <div className={styles.subContent}>{getSubContent(item)}</div>
            </div>
            {item && <HeaderContent item={item} />}
        </div>
    );
};

export default TradeInHeader;
